// ─────────────────────────────────────────────────────────────────
// Glass-i — Organization chart API client (Stage HRMS-3).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const hrOrganizationApi = {
  chart: () => client.get('/api/erp/hrms/organization/chart').then(unwrap)
};

export default hrOrganizationApi;
